import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { generateGlobalColumns, IDataGridConfig } from '@ts/storybook';
import { IConfigComponent, CCategory } from '@ts/ui-models';

interface ICategoriesProps {
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'categories',
  aclId: 'Category',
  entity: 'category',
  fetchURL: '/api/v3/category',
  mainClass: CCategory,
};

const Categories = (props: ICategoriesProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({
      ...props,
      configComponent,
      isEditable: true,
      isFilterable: true,
      isSortable: true,
    });
    return [globalCells.id(), globalCells.name()];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      customDeleteModal={{ message: 'This will also erase associations related to the item' }}
      inheritedProps={inheritedProps}
      enabledFilters //V3
      enabledSort //V3
    />
  );
};

export default Categories;
